export default (function () {
  $('.project .slider_mob').not('.slick-initialized').each(function () {
    var dotsOnMobile = $(this).parents('.project').data('dots_on_mobile');
    var loopSlider = $(this).parents('.project').data('loop');
    var sliderLength = $(this).find('.item_slide').length;
    var swipe = false;

    if (sliderLength > 6 || loopSlider == true) {
      swipe = true;
    }

    $(this).slick({
      dots: false,
      arrows: true,
      infinite: loopSlider,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 1,
      draggable: true,
      swipe: swipe,
      responsive: [{
        breakpoint: 1260,
        settings: {
          infinite: false,
          swipe: true
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          dots: dotsOnMobile,
          infinite: false,
          swipe: true
        }
      }]
    });
    var slideHeight = $(this).find('.item_slide').height();
    var imageHeight = $(this).find('.item_slide').find('img').height();
    var titleHeight = slideHeight - imageHeight;
    $(this).find('.item_slide').find('.item_slide__title').height(titleHeight);
  });
  $('.project .slide-left').click(function () {
    $(this).parents('.project').find('.slick-prev').click();
  });
  $('.project .slide-right').click(function () {
    $(this).parents('.project').find('.slick-next').click();
  });
  $('.page-slider_2, .certificates').not('.slick-initialized').on('init', function (event, slick) {
    var totalNumber = n(slick.slideCount);
    var currentNumber = n(parseInt(slick.currentSlide + 1));

    if (totalNumber !== '01' && $(this).find('.counter').length < 1) {
      // $(this).parents(".slick-wrapper").append("<div class='counter'><span class='current'>" + currentNumber + "</span> / <span class='total'>" + totalNumber + "</span></div>")
      $(this).parents('.slick-wrapper').find('.counter-controls__counter').html("<span class=\"current\">".concat(currentNumber, "</span> / <span class=\"total\">").concat(totalNumber));
    }
  });
  $('.page-slider_2, .certificates').not('.slick-initialized').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    var totalNumber = n(slick.slideCount);
    var currentNumber = n(parseInt(slick.currentSlide + 1)); // $(this).parents(".slick-wrapper").find(".counter").html('<span class="current">' + currentNumber + '</span> / <span class="total">' + totalNumber);

    $(this).parents('.slick-wrapper').find('.counter-controls__counter').html("<span class=\"current\">".concat(currentNumber, "</span> / <span class=\"total\">").concat(totalNumber));
  }); // adding "0" to single number

  function n(n) {
    return n > 9 ? "".concat(n) : "0".concat(n);
  }

  $('.page-slider_2').not('.slick-initialized').each(function () {
    var autoplaySettings;

    if ($(this).parents('.slider-block').data('autoplay')) {
      autoplaySettings = $(this).parents('.slider-block').data('autoplay');
    } else {
      autoplaySettings = false;
    }

    if ($(this).parents('.slider-block').hasClass('slider-block--two_slides')) {
      $(this).slick({
        dots: false,
        arrows: true,
        infinite: true,
        // adaptiveHeight: false,
        slidesToShow: 2,
        // variableWidth: true,
        slidesToScroll: 1,
        autoplay: autoplaySettings,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + ' <g transform="translate(-1459.586 -1193.293)">\n' + ' <path d="M9583,14637l-5,5,5,5" transform="translate(-8117 -13443)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' <line x2="19" transform="translate(1461 1199)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' </g>\n' + '</svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + '  <g transform="translate(-1580 -1193.293)">\n' + '  <path d="M9583,14637l-5,5,5,5" transform="translate(11177 15841) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  <line id="Line_94" x2="19" transform="translate(1599 1199) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  </g>\n' + '</svg></button>',
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            variableWidth: false
          }
        }]
      });
    } else {
      $(this).slick({
        dots: false,
        arrows: true,
        infinite: false,
        // adaptiveHeight: false,
        // slidesToShow: 2,
        variableWidth: true,
        slidesToScroll: 1,
        autoplay: autoplaySettings,
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + ' <g transform="translate(-1459.586 -1193.293)">\n' + ' <path d="M9583,14637l-5,5,5,5" transform="translate(-8117 -13443)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' <line x2="19" transform="translate(1461 1199)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' </g>\n' + '</svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + '  <g transform="translate(-1580 -1193.293)">\n' + '  <path d="M9583,14637l-5,5,5,5" transform="translate(11177 15841) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  <line id="Line_94" x2="19" transform="translate(1599 1199) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  </g>\n' + '</svg></button>',
        responsive: [{
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            variableWidth: true
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            variableWidth: false
          }
        }]
      });
    }
  });
  $('.certificates').not('.slick-initialized').each(function () {
    var dotsOnMobile = $(this).parents(".wins").data('dots_on_mobile');
    var dotsOnTablet = $(this).parents(".wins").data('dots_on_tablet');

    if ($(this).find('.items').length < 5) {
      $(this).slick({
        dots: false,
        arrows: true,
        infinite: true,
        // variableWidth: true,
        centerMode: true,
        speed: 300,
        slidesToShow: 4,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            dots: dotsOnTablet
          }
        }, {
          breakpoint: 800,
          settings: {
            variableWidth: true,
            slidesToShow: 3
          }
        }, {
          breakpoint: 600,
          settings: {
            variableWidth: true,
            slidesToShow: 3,
            dots: dotsOnMobile
          }
        }]
      });
    } else {
      var autoplaySettings = $(this).parents(".wins").data('autoplay');

      if ($(this).parents(".wins").hasClass('wins--in_container')) {
        $(this).slick({
          dots: false,
          arrows: true,
          infinite: true,
          centerMode: true,
          speed: 300,
          slidesToShow: 3,
          autoplay: autoplaySettings,
          // autoplaySpeed:1500,
          prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + ' <g transform="translate(-1459.586 -1193.293)">\n' + ' <path d="M9583,14637l-5,5,5,5" transform="translate(-8117 -13443)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' <line x2="19" transform="translate(1461 1199)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' </g>\n' + '</svg></button>',
          nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + '  <g transform="translate(-1580 -1193.293)">\n' + '  <path d="M9583,14637l-5,5,5,5" transform="translate(11177 15841) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  <line id="Line_94" x2="19" transform="translate(1599 1199) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  </g>\n' + '</svg></button>',
          responsive: [{
            breakpoint: 1024,
            settings: {
              dots: dotsOnTablet
            }
          }, {
            breakpoint: 600,
            settings: {
              dots: dotsOnMobile,
              slidesToShow: 2
            }
          }]
        });
      } else {
        $(this).slick({
          dots: false,
          arrows: true,
          infinite: true,
          variableWidth: true,
          centerMode: true,
          speed: 300,
          // slidesToShow: 5,
          autoplay: autoplaySettings,
          // autoplaySpeed:1500,
          prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + ' <g transform="translate(-1459.586 -1193.293)">\n' + ' <path d="M9583,14637l-5,5,5,5" transform="translate(-8117 -13443)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' <line x2="19" transform="translate(1461 1199)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' </g>\n' + '</svg></button>',
          nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + '  <g transform="translate(-1580 -1193.293)">\n' + '  <path d="M9583,14637l-5,5,5,5" transform="translate(11177 15841) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  <line id="Line_94" x2="19" transform="translate(1599 1199) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  </g>\n' + '</svg></button>',
          responsive: [{
            breakpoint: 1024,
            settings: {
              dots: dotsOnTablet
            }
          }, {
            breakpoint: 600,
            settings: {
              dots: dotsOnMobile
            }
          }]
        });
      }
    }
  });
  $('.post_slider .slide-left').click(function () {
    $(this).parent('.post_slider').find('.slick-prev').click();
  });
  $('.post_slider .slide-right').click(function () {
    $(this).parent('.post_slider').find('.slick-next').click();
  });
  $('.post_slider .counter-controls__left').click(function () {
    $(this).parents('.post_slider').find('.slick-prev').click();
  });
  $('.post_slider .counter-controls__right').click(function () {
    $(this).parents('.post_slider').find('.slick-next').click();
  });
  $('.forwerts_slider .slide-left').click(function () {
    $(this).parents('.forwerts_slider').find('.slick-prev').click();
  });
  $('.forwerts_slider .slide-right').click(function () {
    $(this).parents('.forwerts_slider').find('.slick-next').click();
  });
  $('.forwerts_slider .counter-controls__left').click(function () {
    $(this).parents('.forwerts_slider').find('.slick-prev').click();
  });
  $('.forwerts_slider .counter-controls__right').click(function () {
    $(this).parents('.forwerts_slider').find('.slick-next').click();
  });
  $('.certificates-wrapper .slide-left').click(function () {
    $(this).parent('.certificates-wrapper').find('.slick-prev').click();
  });
  $('.certificates-wrapper .slide-right').click(function () {
    $(this).parent('.certificates-wrapper').find('.slick-next').click();
  });
  $('.certificates-wrapper .counter-controls__left').click(function () {
    $(this).parents('.certificates-wrapper').find('.slick-prev').click();
  });
  $('.certificates-wrapper .counter-controls__right').click(function () {
    $(this).parents('.certificates-wrapper').find('.slick-next').click();
  });
  $('.certificates_2_rows').not('.slick-initialized').each(function () {
    var autoplaySettings = $(this).parents('.wins-2').data('autoplay');
    $(this).slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 4,
      speed: 300,
      autoplay: autoplaySettings,
      prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + ' <g transform="translate(-1459.586 -1193.293)">\n' + ' <path d="M9583,14637l-5,5,5,5" transform="translate(-8117 -13443)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' <line x2="19" transform="translate(1461 1199)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + ' </g>\n' + '</svg></button>',
      nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="11.414" viewBox="0 0 20.414 11.414">\n' + '  <g transform="translate(-1580 -1193.293)">\n' + '  <path d="M9583,14637l-5,5,5,5" transform="translate(11177 15841) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  <line id="Line_94" x2="19" transform="translate(1599 1199) rotate(180)" fill="none" stroke="#4F4E56" stroke-width="2"/>\n' + '  </g>\n' + '</svg></button>',
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }]
    });
  });

  function articlesSlider() {
    $('.related').slick({
      dots: false,
      arrows: false,
      infinite: false,
      variableWidth: true,
      // centerMode: true,
      speed: 300,
      slidesToShow: 1
    });
    $('.mindset .articles_block').slick({
      dots: false,
      arrows: false,
      infinite: false,
      variableWidth: true,
      // centerMode: true,
      speed: 300,
      slidesToShow: 1
    });
  }

  if ($(window).width() < 760) {
    $('.related, .mindset .articles_block').on('init', function (event, slick) {});
    articlesSlider();
  }

  jQuery(window).on('resize', function () {
    var viewportWidth = jQuery(window).width();

    if (viewportWidth > 761) {
      $('.related').slick('unslick');
      $('.mindset .articles_block').slick('unslick');
    } else {
      articlesSlider();
    }
  });
  $('.carousel-wrap').each(function () {
    var $number = $(this).data('number');
    var groupCells;

    if ($number == 2) {
      groupCells = 2;
    } else if ($number == 4) {
      groupCells = 4;
    } else {
      groupCells = true;
    }

    var dotsOnMobile = $(this).parents('.new_slider').data('dots_on_mobile');
    var dotsOnTablet = $(this).parents('.new_slider').data('dots_on_tablet');
    var options = {
      pageDots: false,
      imagesLoaded: true,
      adaptiveHeight: true,
      contain: true,
      groupCells: groupCells,
      watchCSS: true,
      cellAlign: 'left'
    };

    if (matchMedia('(min-width:768px) and (max-width: 1024px)').matches) {
      options.pageDots = dotsOnTablet;
    }

    if (matchMedia('(min-width:0px) and (max-width: 767px)').matches) {
      options.pageDots = dotsOnMobile;
    }

    var $carousel = $('.carousel').flickity(options);
    var flkty = $carousel.data('flickity');
    var count = $carousel.find('.carousel-cell').length;
    var countRes = count < 10 ? "0".concat(count) : count;
    $carousel.parent().find('.carousel-numbers').html("<span class=\"count\">01 / ".concat(countRes, "</span>")); // on slide select

    $carousel.on('select.flickity', function () {
      var currentSlide = flkty.selectedIndex;
      var num = currentSlide < 9 ? "0".concat(currentSlide + 1) : currentSlide + 1;
      var count = $carousel.find('.carousel-cell').length;
      var countRes = count < 10 ? "0".concat(count) : count;
      $carousel.parent().find('.carousel-numbers').html("<span class=\"count\">".concat(num, " / ").concat(countRes, "</span>"));
    });
  }); // animated text slider

  var animatedTextSlider = $('.animated-text-slider');
  animatedTextSlider.not('.slick-initialized').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    fade: true,
    autoplaySpeed: 10000,
    responsive: [{
      breakpoint: 767,
      settings: {
        autoplaySpeed: 3000,
        speed: 2000,
        adaptiveHeight: true
      }
    }]
  });
  animatedTextSlider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
    var targets = '.slick-slide.slick-current.slick-active .animated-text-slider__left-text .letter';
    anime.timeline({
      loop: false
    }).add({
      targets: targets,
      translateY: [100, 0],
      translateZ: 0,
      opacity: [0, 1],
      easing: 'easeOutExpo',
      duration: 1400,
      delay: function delay(el, i) {
        return 300 + 30 * i;
      }
    }).add({
      targets: targets,
      translateY: [0, -100],
      opacity: [1, 0],
      easing: 'easeInExpo',
      duration: 1200,
      delay: function delay(el, i) {
        return 3000 + 30 * i;
      }
    });
    var targets2 = '.slick-slide.slick-current.slick-active .animated-text-slider__right-text .letter';

    if (window.matchMedia('(max-width: 767px)').matches) {
      anime.timeline({
        loop: false
      }).add({
        targets: targets2,
        translateY: [100, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: 'easeOutExpo',
        duration: 1400,
        delay: function delay(el, i) {
          return 300 + 30 * i * 2;
        }
      }).add({
        targets: targets2,
        translateY: [0, -100],
        opacity: [1, 0],
        easing: 'easeInExpo',
        duration: 1200,
        delay: function delay(el, i) {
          return 4000 + 30 * i;
        }
      });
    } else {
      anime.timeline({
        loop: false
      }).add({
        targets: targets2,
        translateY: [100, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: 'easeOutExpo',
        duration: 1400,
        delay: function delay(el, i) {
          return 300 + 30 * i * 2;
        }
      }).add({
        targets: targets2,
        translateY: [0, -100],
        opacity: [1, 0],
        easing: 'easeInExpo',
        duration: 1200,
        delay: function delay(el, i) {
          return 3000 + 30 * i;
        }
      });
    }
  }); // featured boxes

  var featuredBoxesSlider = $('.featured-boxes-slider');
  featuredBoxesSlider.not('.slick-initialized').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    variableWidth: true
  });
  $('.featured-boxes .slide-left').click(function () {
    $(this).siblings('.featured-boxes-slider').find('.slick-prev').click();
  });
  $('.featured-boxes .slide-right').click(function () {
    console.log('fdgd');
    $(this).siblings('.featured-boxes-slider').find('.slick-next').click();
  }); // text image slider

  var textImageSlider = $('.text-image-slider__slider');
  textImageSlider.not('.slick-initialized').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    fade: true
  });
  var cursor = $(".cursor");
  $('.slide-left, .slide-right').mousemove(function (e) {
    cursor.css({
      top: e.clientY - cursor.height() / 2,
      left: e.clientX - cursor.width() / 2
    });
  });
  $('.slide-left, .slide-right').mouseleave(function () {
    cursor.css({
      opacity: "0"
    });
  }).mouseenter(function () {
    cursor.css({
      opacity: "1"
    });
  });
  $(".slide-left").mouseenter(function () {
    cursor.addClass("slide-left-active");
  }).mouseleave(function () {
    cursor.removeClass("slide-left-active");
  });
  $(".slide-right").mouseenter(function () {
    cursor.addClass("slide-right-active");
  }).mouseleave(function () {
    cursor.removeClass("slide-right-active");
  });
});